import React from "react";
import "./styles.css"

function QuoteBanner() {
  return (
    <div className="quote-banner">
      <h2>"The Supernatural is the natural not yet understood" - Elbert Hubbard</h2>
      <div>
      <p>Discover stories, evidence, and more about the paranormal world.</p>
      <p>👻👻👻👻👻👻👻👻👻👻👻👻👻👻👻</p>
    </div>
    </div>
  );
}

export default QuoteBanner;
